import {
  vsProviderName as WorkItemTypeServiceProviderName,
  WorkItemTypeServiceProvider,
} from "./provider";

WorkItemTypeServiceProviderConfig.$inject = [WorkItemTypeServiceProviderName];
export function WorkItemTypeServiceProviderConfig(
  workItemTypeServiceProvider: WorkItemTypeServiceProvider
) {
  const optionTemplate = require("!html-loader!./option/index.html").default;
  const confirmationTemplate = require("!html-loader!./confirmation/index.html").default;
  const commentTemplate = require("!html-loader!./comment/index.html").default;
  const signatureTemplate = require("!html-loader!./Signature/index.html").default;
  const dateTemplate = require("!html-loader!./date/index.html").default;

  workItemTypeServiceProvider.addConfig({
    name: "Option",
    template: optionTemplate,
  });

  workItemTypeServiceProvider.addConfig({
    name: "Conditional",
    template: optionTemplate,
  });
  workItemTypeServiceProvider.addConfig({
    name: "Confirmation",
    template: confirmationTemplate,
  });
  workItemTypeServiceProvider.addConfig({
    name: "Comment",
    template: commentTemplate,
  });
  workItemTypeServiceProvider.addConfig({
    name: "Signature",
    template: signatureTemplate,
  });
  workItemTypeServiceProvider.addConfig({
    name: "Date",
    template: dateTemplate,
  });
}
